import AdminRidersPage from '../../../components/admin/riders/AdminRidersPage'

export default function Riders() {
  return <AdminRidersPage />
}
